
//     Init Tabs Component
//
//     Attributes accept:
//     - toggle-class-only: {bool} Only toggle the "active" class instead of toggling display (optional)
//
//     Usage:
//     <w3-tabs></w3-tabs>

class NavTabs extends HTMLElement {
    constructor() {
        super();

        this.setActiveTab = this.setActiveTab.bind(this);
   }

    connectedCallback() {
        this.Tabs = {};
        this.tabsContainerEl = this;
        this.tabsNavEls = this.tabsContainerEl.querySelectorAll('.js-tab-nav');
        this.tabsContentEls = this.tabsContainerEl.querySelectorAll('.js-tab-content');

        this.toggleClassOnly = this.tabsContainerEl.hasAttribute('toggle-class-only') || false;

        this.tabsNavEls.forEach(tabEl => {
            tabEl.addEventListener('click', this.setActiveTab);
        });
    }

   setActiveTab(event) {
        // first remove all active class on tab and content
        this.tabsNavEls.forEach(tabEl => {
            if (tabEl.classList.contains('active')) {
                tabEl.classList.remove('active');
            }
        });

        this.tabsContentEls.forEach(tabEl => {
            if (!this.toggleClassOnly) {
                tabEl.style.display = "none";
            }

            if (tabEl.classList.contains('active')) {
                tabEl.classList.remove('active');
            }
        });

        // get target tab
        let activeTabNav = event.currentTarget;
        let targetTabName = activeTabNav.getAttribute('data-target');
        let activeTabContent = this.tabsContainerEl.querySelector(targetTabName);

        // get toggle class
        if (activeTabNav) { activeTabNav.classList.add('active'); }
        if (activeTabContent) { activeTabContent.classList.add('active'); }
        if (activeTabContent && !this.toggleClassOnly) { activeTabContent.style.display = "block"; }
    }
}

customElements.define('w3-tabs', NavTabs);
